import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "number-control-container" }
const _hoisted_2 = ["value"]




export default /*@__PURE__*/_defineComponent({
  __name: 'QuantityEditor',
  props: {
  modelValue: {
    type: Number,
  },
  disable: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue'],
  setup(__props) {

const props = __props;


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_icon, {
      class: _normalizeClass([{'disable': __props.disable}, "number-control-minus"]),
      color: "grey",
      icon: "fa-minus",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', props.modelValue ? props.modelValue - 1 : 0)))
    }, null, 8, ["class"]),
    _createElementVNode("input", {
      class: _normalizeClass([{'disable': __props.disable}, "number-control"]),
      value: __props.modelValue,
      density: "compact",
      type: "number",
      variant: "outlined",
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
    }, null, 42, _hoisted_2),
    _createVNode(_component_v_icon, {
      class: _normalizeClass([{'disable': __props.disable}, "number-control-plus"]),
      color: "grey",
      icon: "fa-plus",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', props.modelValue + 1)))
    }, null, 8, ["class"])
  ]))
}
}

})